<ng-template #content>
    <ng-content></ng-content>
</ng-template>

<header
    class="header{{marginTop ? ' -margin-top-'+marginTop : ''}}{{marginBottom ? ' -margin-bottom-'+marginBottom : ''}}{{paddingTop ? ' -padding-top-'+paddingTop : ''}}{{paddingBottom ? ' -padding-bottom-'+paddingBottom : ''}}"
    [ngClass]="{'has-right-col': right, '-inverted': inverted, '-center': center}">
    <div class="header__inner">
        <div class="header__col -left" *ngIf="left">
            <ng-container *ngTemplateOutlet="left || null"></ng-container>
        </div>

        <div class="header__col -main" [ngClass]="{'-width-full': !right}">
            <ng-container *ngIf="type">
                <shared-h [center]="center" [ellipsis]="ellipsis" [loading]="loading" [counter]="counter"
                    [postContent]="postContent" [preContent]="preContent" [type]="type" [inverted]="inverted"
                    [paddingTop]="'none'" [marginTop]="'none'" [marginBottom]="'none'" [brandAccent]="brandAccent">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </shared-h>
            </ng-container>

            <ng-container *ngIf="!type">
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </ng-container>
        </div>

        <div class="header__col -right" *ngIf="right">
            <ng-container *ngTemplateOutlet="right || null"></ng-container>
        </div>

    </div>
</header>
